var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('SaralaTable',{attrs:{"model":_vm.model,"createRoute":{ name: 'notifications.create' }},scopedSlots:_vm._u([{key:"exibition",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(item.exibition)+"\n        ")]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(item.status
                    ? _vm.$t('resources.default.active')
                    : _vm.$t('resources.default.inactive'))+"\n        ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }